import { render, staticRenderFns } from "./HabilitarAlertaTransmissao.vue?vue&type=template&id=2bff0112&scoped=true"
import script from "./HabilitarAlertaTransmissao.vue?vue&type=script&lang=js"
export * from "./HabilitarAlertaTransmissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff0112",
  null
  
)

export default component.exports